import api from './api';

const listProjectLinks = query => api.get(`/api/project-links/?project=${query.project}`);

const updateProjectLinks = ({ id, links }) =>
  api.post(`/api/project-links/bulk/?project=${id}`, links);

export default { listProjectLinks, updateProjectLinks };
